import useStores from './useStores';

export const makeUseStoreHook = storeName =>
  dataSelector => useStores(stores => stores[storeName], dataSelector);

const toPascalCase = storeName =>
  `${storeName.slice(0, 1).toUpperCase()}${storeName.slice(-(storeName.length - 1))}`;

export const makeUseStoreHookName = storeName =>
  `use${toPascalCase(storeName)}`;
